import {useCallback} from 'react'

import TextInput from '../../../../common/components/Form/TextInput.js'
import TextArea from '../../../../common/components/Form/TextArea.js'
import Row from '../../../../common/components/Form/Row.js'

export default function EditLine({index, line, ...props}) {
  const errors = props.data.errors?.lines?.[index] || {}

  const onChange = useCallback(
    (payloadDelta) => {
      const lines = [...props.data.payload.lines]

      lines[index] = {...line, ...payloadDelta}

      props.updatePayload(props.data.index, {lines})
    },
    [index],
  )

  return (
    <div key={index} className="wrap--edit-order-line">
      <Row>
        <TextInput
          value={line.sku}
          errorMessage={errors.sku}
          name={`${index}_sku`}
          label="SKU"
          className="medium-12"
          onChange={(value) => onChange({sku: value})}
        />
      </Row>
      <Row>
        <TextInput
          value={line.requested_quantity}
          errorMessage={errors.requested_quantity}
          name={`${index}_requested_quantity`}
          label="Requested Quantity"
          className="medium-12"
          onChange={(value) => onChange({requested_quantity: value})}
        />
      </Row>
      <Row>
        <TextInput
          value={line.unit_cost}
          errorMessage={errors.unit_cost}
          name={`${index}_unit_cost`}
          label="Unit Cost"
          className="medium-6"
          onChange={(value) => onChange({unit_cost: value})}
        />
        <TextInput
          value={line.labor_unit_cost}
          errorMessage={errors.labor_unit_cost}
          name={`${index}_labor_unit_cost`}
          label="Labor Unit Cost"
          className="medium-6"
          onChange={(value) => onChange({labor_unit_cost: value})}
        />
      </Row>
      <Row>
        <TextArea
          value={line.internal_notes}
          errorMessage={errors.internal_notes}
          name={`${index}_internal_notes`}
          rows="3"
          label="Internal Notes"
          className="medium-12"
          onChange={(value) => onChange({internal_notes: value})}
        />
      </Row>
      <Row>
        <TextArea
          value={line.manufacturer_notes}
          errorMessage={errors.manufacturer_notes}
          name={`${index}_manufacturer_notes`}
          rows="3"
          label="Manufacturer Notes"
          className="medium-12"
          onChange={(value) => onChange({manufacturer_notes: value})}
        />
      </Row>
    </div>
  )
}
